//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Issue.js";
import "../no/NXObject.js";
let d=[[[0,"FolderType",0,0]],[[["nAttachments"],"GetAttachments",{R_:{attachments:"Issue.IssueAttachment[]"}},0,0],[["attachment"],"AddAttachment",{},1,0],[["attachment"],"RemoveAttachment",{},1,0]],[]];
SPLM.Issue.IssueFolder = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Issue.IssueFolder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Issue.IssueFolder.Type = Object.freeze({
    "ProblemItems" : "ProblemItems", "ImpactedItems" : "ImpactedItems", "ReferenceItems" : "ReferenceItems", "ImplementedBy" : "ImplementedBy", "IssueImage" : "IssueImage", "IssueFixedImage" : "IssueFixedImage", "SnapshotBeforeFix" : "SnapshotBeforeFix", "SnapshotAfterFix" : "SnapshotAfterFix", "ValidationResults" : "ValidationResults"});

export default SPLM;